import { Navigate, Outlet, useLocation } from "react-router-dom";

import { LOGIN_ROUTE } from "@/routing/AppRouter/routes.constants";

export interface IPrivateClientRouterProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isClient: boolean;
}

export const PrivateClientRoute = ({ isAuthenticated, isAdmin, isClient }: IPrivateClientRouterProps) => {
  const location = useLocation();
  if (!(isAuthenticated && (isClient || isAdmin))) {
    return (
      <Navigate to={`/${LOGIN_ROUTE}`} state={{ redirectPath: location.pathname + location.search + location.hash }} />
    );
  }

  return <Outlet />;
};
